export default class ProfessionalSkill {
  title;
  proficiency;
  constructor(data) {
    this.title = data?.title;
    this.proficiency = data?.proficiency;
  }
}
